import TiersApi from '@/api/tiers';
import StoreBuilder from '../store-builder';

const builder = new StoreBuilder('tiers');
builder.addStatePart('tiers', null, numTiers => TiersApi.getByNumTiers(numTiers));

export default builder.build();
